// extracted by mini-css-extract-plugin
export default {"main_footer_container":"pageFooter-module--main_footer_container--O0wJ9"};